// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2zUPy","buttons":"PendingPaymentAlert_buttons__3cUPa"};